import { Helmet } from "react-helmet-async";

export const SITE_URL = "https://careforme.gr";
const OG_IMAGE = `${SITE_URL}/og-image.jpg`;

// Per-route SEO: title, description, canonical, Open Graph + Twitter cards.
// The static head in public/index.html is the crawler fallback; this refines it per page.
export const Seo = ({ title, description, path = "/", image, type = "website", noindex = false }) => {
  const url = `${SITE_URL}${path}`;
  const img = image || OG_IMAGE;
  return (
    <Helmet prioritizeSeoTags>
      <title>{title}</title>
      {description && <meta name="description" content={description} />}
      <link rel="canonical" href={url} />
      <meta name="robots" content={noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large, max-snippet:-1"} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={img} />
    </Helmet>
  );
};
